export const checkFieldsForValidity = (fields) => {
    let valid = true;
    for(let property in fields){
        const f = fields[property];
        const v = f.validator(f.value)
        if(v === false){
            valid = false;
        }
    }

    return valid;
};

export const touchAll = (fields) => {
    let newFields = {
        ...fields
    }
    for(let property in newFields){
        newFields = {
            ...newFields,
            [property]: {
                ...newFields[property],
                is_touched: true
            }
        }

    }

    return newFields;
};